<template>
  <div>
    <el-card style="margin-bottom: 20px;">
      <el-form :model="queryParam" size="small" label-position="top">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('operationCenter.date')">
              <el-date-picker
                v-model="queryParam.dateTimeRange"
                type="datetimerange"
                range-separator="-"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptions"
                :default-time="['00:00:00', '23:59:59']"
                :start-placeholder="$t('GlobalSetObj.startDate')"
                :end-placeholder="$t('GlobalSetObj.endDate')"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('collectionCenter.businessT')">
              <el-select
                v-model="queryParam.businessType"
                :placeholder="$t('GlobalSetObj.all')"
                clearable
                style="width: 100%;"
              >
                <el-option key="1" :label="$t('collectionCenter.expressDelivery')" :value="0" /><!--快递-->
                <el-option key="2" :label="$t('collectionCenter.collect')" :value="1" /><!--揽收-->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!--  客户  -->
            <el-form-item :label="$t('GlobalSetObj.client')">
              <el-select
                v-model="queryParam.customerId"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                :remote-method="getCustomerPage"
                clearable
                filterable
                remote
                reserve-keyword
                collapse-tags
                style="width: 100%"
                @visible-change="getCustomerPage()"
                @change="customerIdChange(queryParam.customerId)"
              >
                <el-option
                  v-for="item in customerList"
                  :key="item.id"
                  :label="item.customerAlias + '（' + item.username + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item>
              <el-button type="primary" @click="searchData()">{{ $t('operationCenter.Procurar') }}</el-button>
              <el-button @click="resetQueryParam()">{{ $t('collectionCenter.reset') }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-card>
          <div ref="statisticsRef" style="height: calc(100vh - 360px)" />
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <div ref="otherRef" style="height: calc(100vh - 360px)" />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { apiCustomerPage } from '@/api/customer';
import { getCteInvoiceException } from '@/api/invoiceCenter';
import * as echarts from 'echarts';
import dayjs from 'dayjs';
export default {
  name: 'CTeInvoicingExceptionStatistics',
  data() {
    return {
      queryParam: {
        dateTimeRange: this.getDate(),
        customerId: null,
        businessType: null
      },
      pickerMinDate: '',
      pickerRange: 30 * 24 * 60 * 60 * 1000, // 可选择日期范围 为15天
      pickerOptions: {
        // 设置不能选择的日期
        onPick: ({ minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            return (time.getTime() > (this.pickerMinDate + this.pickerRange)) || (time.getTime() < (this.pickerMinDate - this.pickerRange));
          }
          return false;
        }
      },
      customerList: [],
      chart1: null,
      otherChart: null,
      allCount: 0,
      allOtherCount: 0,
      customerName: null
    };
  },
  created() {
    this.getCustomerPage();
    this.searchData();
  },
  mounted() {
    window.addEventListener('resize', this.resizeChart);
  },
  methods: {
    // 获取当前时间
    getDate() {
      const date = dayjs().format('YYYY-MM-DD');
      return [date + ' 00:00:00', date + ' 23:59:59'];
    },
    // 获取客户选项
    getCustomerPage(name = '') {
      const param = {
        pageSize: 20,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiCustomerPage(param, false).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    },
    // 客户选项改变
    customerIdChange(id) {
      if (id) {
        this.customerName = this.customerList.find(item => item.id === id).customerAlias;
      } else {
        this.customerName = null;
      }
    },
    // 搜索
    searchData() {
      if (!this.queryParam.dateTimeRange || this.queryParam.dateTimeRange.length < 2) {
        this.$message.error(this.$t('basicData.SelectADatetime'));
        return;
      }
      const param = {
        startTime: this.queryParam.dateTimeRange[0] || null,
        endTime: this.queryParam.dateTimeRange[1] || null,
        customerId: this.queryParam.customerId || null,
        businessType: this.queryParam.businessType || null
      };
      const optionData = (data, allCount) => {
        console.log(data, '===data');
        return {
          tooltip: {
            trigger: 'item',
            formatter: function(params) {
              return params.data.name + ': ' + params.data.value + '（' + (params.data.value / allCount * 100).toFixed(2) + '%）';
            }
          },
          legend: {
            type: 'scroll',
            top: '5%',
            left: 'left',
            orient: 'vertical',
            height: '90%',
            width: 150,
            formatter: function(name) {
              // 英文按字符数截断，但 W 和 i 宽度差异大，效果不够精准
              const maxLen = 20;
              return name.length > maxLen ? name.substring(0, maxLen) + '...' : name;
            },
            tooltip: {
              show: true, // 悬停显示完整名称
              confine: true,
              formatter: params => params.name,
              extraCssText: 'white-space: normal; overflow-wrap: break-word; word-wrap: break-word; max-width: 300px;'
            }
          },
          series: [
            {
              type: 'pie',
              radius: ['0%', '40%'],
              center: ['70%', '50%'],
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 0,
                borderColor: '#fff',
                borderWidth: 0
              },
              label: {
                show: false,
                position: 'center'
              },
              emphasis: {
                label: {
                  show: false
                }
              },
              data: data
            }
          ]
        };
      };
      getCteInvoiceException(param).then(res => {
        const _that = this;
        if (res.code === 200) {
          const statusRef = this.$refs.statisticsRef;
          const colors = ['#2663cc', '#8000d7', '#20be89', '#ff4a4a', '#6b7280', '#f59e0b'];
          const statusData = [];
          this.allCount = 0;
          res.data.dimensionStats.map((item, index) => {
            this.allCount += item.count;
            const pieChart = {
              ...item,
              value: item.count,
              itemStyle: { color: colors[index] }
            };
            statusData.push(pieChart);
          });
          console.log(statusData, '====statusData');
          this.chart1 = echarts.init(statusRef);
          this.chart1.setOption(optionData(statusData, this.allCount));
          // 3. 监听点击事件
          this.chart1.off('click');
          this.chart1.on('click', function(params) {
            console.log('点击了：', params);
            const paramData = {
              invoiceIssueTime: _that.queryParam.dateTimeRange || [],
              businessType: (_that.queryParam.businessType || _that.queryParam.businessType === 0) ? _that.queryParam.businessType : params.data.businessType,
              customerName: _that.customerName ? _that.customerName : params.data.customerName,
              customerId: _that.queryParam.customerId || params.data.customerId,
              failedReason: null
            };
            console.log(paramData, '===paramData');
            // 在这里处理你的业务逻辑
            _that.$router.push({
              name: 'CteCreationFailed',
              params: paramData
            });
          });
          // 其他
          const otherDataRef = this.$refs.otherRef;
          const otherData = [];
          this.allOtherCount = 0;
          res.data.reasonStats.map((item, index) => {
            this.allOtherCount += item.count;
            const pieChart = {
              ...item,
              value: item.count,
              itemStyle: { color: colors[index] }
            };
            otherData.push(pieChart);
          });
          this.otherChart = echarts.init(otherDataRef);
          this.otherChart.setOption(optionData(otherData, this.allOtherCount));
          // 3. 监听点击事件
          this.otherChart.off('click');
          this.otherChart.on('click', function(params) {
            console.log('点击了：', params);
            const paramData = {
              invoiceIssueTime: _that.queryParam.dateTimeRange || [],
              businessType: (_that.queryParam.businessType || _that.queryParam.businessType === 0) ? _that.queryParam.businessType : params.data.businessType,
              customerName: _that.customerName ? _that.customerName : params.data.customerName,
              customerId: _that.queryParam.customerId || params.data.customerId,
              failedReason: params.data.name || null
            };
            console.log(paramData, '===paramData');
            // 在这里处理你的业务逻辑
            _that.$router.push({
              name: 'CteCreationFailed',
              params: paramData
            });
          });
        }
      });
    },
    // 重置查询参数
    resetQueryParam() {
      this.queryParam = {
        dateTimeRange: this.getDate(),
        customerId: null,
        businessType: null
      };
      this.searchData();
    },
    resizeChart() {
      if (this.otherChart) {
        this.otherChart.resize();
      }
      if (this.chart1) {
        this.chart1.resize();
      }
    }
  }
};
</script>

<style scoped>

</style>
